import IconTasks from '@/components/icons/IconTasks.vue';
import IconProxies from '@/components/icons/IconProxies.vue';
import IconAccounts from '@/components/icons/IconAccounts.vue';
import IconJobs from '@/components/icons/IconJobs.vue';
import IconSubscription from '@/components/icons/IconSubscription.vue';
import IconProfile from '@/components/icons/IconProfile.vue';
import IconDashboard from '@/components/icons/IconDashboard.vue';

import HeaderMegaMenu from '@/components/partials/HeaderMegaMenu.vue';

import { storeAuth } from '@ozdao/martyrs/modules/auth/client';
import { state as accountsState } from '@/store/accounts.js';

// Бейдж «Аккаунты (N flagged)» — читаем напрямую из reactive state.
// Доступ к полю трекается реактивностью Vue, поэтому при изменении
// flaggedCount сайдбар перерисовывается сам.

// Мега-меню «Инструменты» — компонент сам владеет своими данными и иконками.
// Navigation прокидывает только сам компонент через `dropdownComponent`.
export const headerNavigationItems = [
  {
    items: [
      // Только реальные URL: этот же массив наследуют все дочерние роуты Home
      // (лендинги /tools/*, блог, FAQ), а якоря #features/#safety/#pricing
      // существовали лишь на главной и с остальных страниц никуда не вели.
      { title: 'Инструменты',  dropdownComponent: HeaderMegaMenu },
      { title: 'Тарифы',       route: '/pricing' },
      { title: 'Блог',         route: '/community' },
      { title: 'Вопросы',      route: '/faq' },
    ],
  },
];

export const sidebarNavigationItems = [
  {
    items: [
      {
        title: 'Дашборд',
        iconComponent: IconDashboard,
        route: '/dashboard',
      },
      {
        title: 'Аккаунты',
        iconComponent: IconAccounts,
        route: '/dashboard/accounts',
        get badge() { return accountsState.flaggedCount; },
      },
      {
        title: 'Задачи',
        iconComponent: IconTasks,
        route: '/dashboard/tasks',
      },
      {
        title: 'Прокси',
        iconComponent: IconProxies,
        route: '/dashboard/proxies',
      },
      {
        title: 'Лента джобов',
        iconComponent: IconJobs,
        route: '/dashboard/jobs',
      },
      {
        title: 'Подписка',
        iconComponent: IconSubscription,
        route: '/dashboard/subscription',
      },
      {
        title: 'Профиль',
        iconComponent: IconProfile,
        // martyrs auth (контекст 'client', см. global.config.js) даёт `/profile`,
        // `/profile/edit/*`, `/profile/dashboard` без ID в URL — это и есть «свой профиль».
        // Просмотр чужого профиля живёт под `/users/:_id`, админский edit — под `/backoffice/users/:_id`.
        route: '/profile',
      },
    ]
  }
];
